const blogs = [
	{
		url:
			"https://saumya66.medium.com/made-gilfoyles-bitcoing-app-from-the-silicon-valley-series-594de798a5a3",
		thumbNail: "https://miro.medium.com/max/875/1*64Cf_t35SwfpTe6r46AbRA.png",
	},
	{
		url:
			"https://www.thecsengineer.com/2020/11/running-the-c-program-that-creates-3d-rotating-donut.html",
		thumbNail: "https://img.youtube.com/vi/SRi0SZoGXkw/0.jpg",
	},
	{
		url: "https://saumya.hashnode.dev/how-i-made-my-first-full-stack-web-app",
		thumbNail: "https://miro.medium.com/max/656/1*93uoYsDUUxdc9Y8ArJP7hw.jpeg",
	},
	{
		url:
			"https://medium.com/saumya-ranjan-nayak/how-does-a-neuron-work-in-a-neural-network-deep-learning-simplified-series-79f322d1222d",
		thumbNail: "https://miro.medium.com/max/656/1*9LI5vINyyYn26uW9aCPbgQ.jpeg",
	},
	{
		url:
			"https://dev.to/saumya66/detecting-a-car-is-tesla-or-not-using-deep-learning-with-fast-ai-4i3p",
		thumbNail: "https://miro.medium.com/max/656/1*kKDMvAoCi0l5oBGw3Y4hNQ.png",
	},
	{
		url:
			"https://www.thecsengineer.com/2020/12/multivariate-linear-regression-gradient-descent-python.html",
		thumbNail:
			"https://1.bp.blogspot.com/-cH7Wcyn8yGs/X_r1LxpmeUI/AAAAAAAAB2I/Glm1DVRK9rYlfOk8f1LQseQ03mWjq-O9wCLcBGAsYHQ/s16000/machine-learning-1920x1180%2B%25281%2529.webp",
	},
];
export default blogs;
